import { Directive, ElementRef, Input } from '@angular/core'
import { NavigationEnd, NavigationStart, Router } from '@angular/router'
import { BaseComponent } from 'common/helpers'

@Directive({
  selector: '[activeLink]',
})
export class ActiveLinkDirective extends BaseComponent {
  @Input('routerLink') href: string
  @Input('activeLink') cls: string

  constructor (
    private router: Router,
    private element: ElementRef<HTMLAnchorElement>,
  ) {
    super()
    this.subs.add(router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.update(event.url)
      }
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          // Catch up with the AngularJS router
          this.update(location.href)
        })
      }
    }))
  }

  ngAfterViewInit () {
    this.update(this.router.url)
  }

  update (url) {
    const newPath = new URL(url, location.href).pathname
    const match = this.href.split('/').every(p => newPath.split('/').includes(p))
    this.element.nativeElement.classList.toggle(this.cls, match)
  }
}
